'use strict';

import { environment } from '@quartz-iam-legacy/environments/environment';

angular.module('directives.userRequests', ['services.authenticatedUser',
                                           'services.userAccessRequest',
                                           'services.search'])

    .directive('userRequest', ['$rootScope', '$modal', '$state', '$translate', 'authenticatedUserService', 'searchService', 'userAccessRequestService', 'selfAccessRequestService', function ($rootScope, $modal, $state, $translate, authenticatedUserService, searchService, userAccessRequestService, selfAccessRequestService) {
    return {
        scope: {
            model: '=',
            requestParams: '@',
            requestTitle: '@',
            inRequestApp: '=?'
        },
        template: '<div ng-include="getTemplateUrl()"></div>',
        link: function (scope, elem, attrs) {

            authenticatedUserService.getAuthenticatedUser().then(function (authUser) {
                scope.authUser = authUser;
            });

            scope.toAssignEmployee = {};
            scope.toAssignEmployee.selected = null;

            scope.inRequestApp = _.isUndefined(scope.inRequestApp) ? true : scope.inRequestApp;

            // Got to process request
            scope.goToProcess = function () {
                window.location = environment.idUrl +
                    '/access-requests(modal:access-request-details)?userAccessRequestId=' +
                    scope.model.UserAccessRequestID;
            }

            /* Get Template */
            scope.version = angular.isDefined(attrs.version) ? attrs.version : 'bootstrap3';
            scope.getTemplateUrl = function () {
                return '/app/shared/components/directives/userRequest.' + scope.version + '.tpl.html';
            }

            /* Properties */
            scope.noTasksToProcess = function () {
                return scope.model.NbCardsToProcess == 0 || scope.model.NotYetToProcess;
            }

            scope.isLocked = function () {
                if (_.isUndefined(scope.model)) return;
                return scope.model.LockByEmployeeID > 0 && !_.isEmpty(scope.model.LockByUsername);
            }

            scope.isFilteredCustodian = function () {
                return scope.authUser.Custodian != null;
            }

            scope.urlToProcess = function() {
                var baseUrl = environment.apiUrl + "/ID/API/UserRequest/Process/" + scope.model.UserAccessRequestID;
                baseUrl += '?searchTerm=' + scope.model.UserAccessRequestID;

                if (!_.isEmpty(scope.model.Custodian)) {
                    baseUrl += "&custodian=" + scope.model.Custodian;
                }

                return baseUrl;
            }

            /* Display actions */
            scope.displayActions = false;

            scope.showOrHideActions = function () {
                scope.displayActions = !scope.displayActions;
            }

            /* UnAssign Request */
            scope.unassignRequest = function () {
                userAccessRequestService.unAssignRequest(scope.model.UserAccessRequestID).then(function (updatedRequest) {
                    _.assign(scope.model, updatedRequest);
                    scope.model.LockByEmployeeID = undefined;
                });
            }



            /* Open modal to search and select employee to be Head or Assistant */
            scope.selectEmployee = function (title) {
                if (title === 'assistant' && !scope.bu.HeadID) return;

                var modalScope = scope.$new(true);

                var employeePickerModal = $modal({
                    scope: modalScope,
                    template: require('../../../Main/admin/adminBusinessUnits/searchEmployee.tpl.html'),
                    placement: 'center',
                    title: $translate.instant('iam.shared.directives.userRequestDirective.transferRequestToEmployee'),
                    show: true
                });

                /* Select employee from searching result list */
                modalScope.selectEmployee = function (employeeSelected) {
                    // Assign New user to request
                    selfAccessRequestService
                        .transferOwnershipOfSelfAccessRequest(scope.model.UserAccessRequestID, employeeSelected.EmployeeID)
                        .then(function (req) {
                            $state.go('userAccessRequest.edit', {
                                userAccessRequestId: scope.model.UserAccessRequestID
                            }, { reload: true });
                        });


                    scope.reqOwner = employeeSelected;
                    employeePickerModal.hide();
                    scope.pageIsDirty();
                }
            };


            /* Assign Request */
            scope.manageAssignRequest = function () {

                scope.refreshEmployees = function (searchTerm) {
                    if (searchTerm.length < 3) return;
                    return searchService.searchActiveEmployees(searchTerm)
                                        .then(function (employees) {
                                            scope.employees = employees;
                                        });
                };

                var chooseAssignModal = $modal({
                    scope: scope,
                    template: require('./chooseAssign.tpl.html'),
                    placement: 'center'
                });

                scope.hideModal = function () {
                    chooseAssignModal.$promise.then(chooseAssignModal.hide);
                };

                var whenAssign = function (updatedRequest) {
                    _.assign(scope.model, updatedRequest);
                    scope.toAssignEmployee.selected = null;
                    scope.hideModal();
                }

                scope.assignToMe = function () {
                    userAccessRequestService.assignRequestToCurrentUser(scope.model.UserAccessRequestID)
                    .then(whenAssign);
                };

                scope.assignToEmployee = function () {
                    userAccessRequestService.assignRequestToEmployee(scope.model.UserAccessRequestID,
                                                                     scope.toAssignEmployee.selected.EmployeeID)
                    .then(whenAssign);
                };
            }
        }
    }
}]);
